import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterTypes, INTIAL_FILTERS } from '../constants/initialFilters';
import { RootState } from '.';

interface FiltersReducerTypes {
  confirmedFilters: FilterTypes;
  availableFilters: any;
}

type SigleFilterAddActionType = {
  [key: string]: string;
};

const initialState: FiltersReducerTypes = {
  confirmedFilters: INTIAL_FILTERS,
  availableFilters: {},
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    // Initially set filters from LS to Redux
    setFiltersFromLS: (state: FiltersReducerTypes, action: PayloadAction<FilterTypes>) => {
      return { ...state, confirmedFilters: action.payload };
    },

    // Initially set available filters from LS to Redux
    setAvailableFilters: (state, action) => {
      return { ...state, availableFilters: action.payload };
    },

    // Remove temp filter from filter menu
    addOrRemoveTempFilter: (state, action: PayloadAction<SigleFilterAddActionType>) => {
      const { filterType, filterValue } = action.payload;
      const filterArray = (state.confirmedFilters as any)[filterType];
      const offerRegionFilters = state.confirmedFilters.offerRegion;

      if (filterType === 'vehicleType') {
        return {
          ...state,
          confirmedFilters: {
            ...state.confirmedFilters,
            vehicleType: filterValue,
            offerRegion: ['NAT'],
          },
        };
      }

      // removing filters for region
      if (
        filterType === 'offerRegion' &&
        filterArray.includes(filterValue) &&
        offerRegionFilters.length === 1
      ) {
        return {
          ...state,
          confirmedFilters: {
            ...state.confirmedFilters,
            offerRegion: ['NAT'],
          },
        };
      }
      // removing filters
      if (filterArray.includes(filterValue)) {
        return {
          ...state,
          confirmedFilters: {
            ...state.confirmedFilters,
            [filterType]: (state.confirmedFilters as any)[filterType].filter(
              (item: string) => item !== filterValue,
            ),
          },
        };
      }

      // adding region filter. Need to remnove NAT always
      if (filterType === 'offerRegion') {
        // Remove NAT when adding new region, to make sure that later when we gonna save state -
        // NAT is going to be the last in array
        const newState = [...state.confirmedFilters.offerRegion, filterValue].filter(
          (toCheck) => toCheck !== 'NAT',
        );
        return {
          ...state,
          confirmedFilters: {
            ...state.confirmedFilters,
            offerRegion: [...newState, 'NAT'],
          },
        };
      }

      return {
        ...state,
        confirmedFilters: {
          ...state.confirmedFilters,
          [filterType]: [...(state.confirmedFilters as any)[filterType], filterValue],
        },
      };
    },

    // Remove filter from everywhere (filter tags and filter menu) + upload fresh filters to LS
    removeFilter: (state, action) => {
      const { filterType, filterValue } = action.payload;
      const offerRegionFilters = state.confirmedFilters.offerRegion;
      if (filterType === 'offerRegion' && offerRegionFilters.length === 1) {
        return {
          ...state,
          confirmedFilters: {
            ...state.confirmedFilters,
            offerRegion: ['NAT'],
          },
        };
      }
      const newState = {
        ...state,
        confirmedFilters: {
          ...state.confirmedFilters,
          [filterType]: (state.confirmedFilters as any)[filterType].filter(
            (item: string) => item !== filterValue,
          ),
        },
      };
      // call filter current state(Data Layer events) when a filter gets removed from filters
      // filterCurrentState(newState.confirmedFilters);
      // localStorage.setItem('us-promo-selectedFilters', JSON.stringify(newState.confirmedFilters));
      return newState;
    },

    // Apply filter from filters menu
    setConfirmedFilters: (state, action) => {
      // Do not add partnerDealers to localStorage
      // const { ...payloadForLS } = action.payload;
      // localStorage.setItem('selectedFilters-v4', JSON.stringify(action.payload));
      return { ...state, confirmedFilters: action.payload };
    },

    // Remove ALL filters from everywhere and set initial ones.
    clearAllFilters: (state) => {
      // Do not add partnerDealers to localStorage
      // const { partnerDealers, ...payloadForLS } = INTIAL_FILTERS;
      // localStorage.setItem('selectedFilters-v4', JSON.stringify(payloadForLS));
      return { ...state, confirmedFilters: INTIAL_FILTERS };
    },
  },
});

export const selectFilters = (state: RootState) => state.filters;

export const {
  setFiltersFromLS,
  setAvailableFilters,
  addOrRemoveTempFilter,
  removeFilter,
  setConfirmedFilters,
  clearAllFilters,
} = filterSlice.actions;

export default filterSlice.reducer;
